<script setup>
import {ref, onBeforeMount} from "vue";
import router from "@/router/index.js";
import createTherapist from "./components/createTherapist/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {addServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";
const {route} = getRoute()

onBeforeMount(() => {
  if (!route.query.tenantId) {
    loading.value = true
    ElMessage.error("暂无商家信息")
  } else if (!route.query.storeId) {
    loading.value = true
    ElMessage.error("暂无理疗服务商信息")
  } else {
    ruleForm.value.tenantId = route.query.tenantId
    ruleForm.value.storeId = route.query.storeId
  }
})
// 加载状态
const loading = ref(false)
/*表单信息相关*/
// 表单
const ruleForm = ref({
  tenantId: null,
  storeId: null,
  avatar: null,
  name: null,
  nameEn: null,
  phone: null,
  gender: null,
  description: null,
  descriptionEn: "Coming Soon ...",
  providerType: "THERAPIST",
  tagIdList: [],
  skillCertificates: []
})
// 处理创建理疗师
const handleCreateTherapist = async () => {
  try {
    loading.value = true
    await addServiceProviderIgnoreTenant(ruleForm.value)
    ElMessage.success("新建成功")
    router.back()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <createTherapist v-loading="loading" v-model="ruleForm" @success="handleCreateTherapist"></createTherapist>
</template>

<style lang="scss" scoped>

</style>
